import React from 'react';
import { Box, Typography } from '@mui/material';

// Kit visual do Academy (mockups de 07/10/2026): cartoes brancos com borda
// creme, titulos Poppins e o quadrado de icone (Bloco3D, hoje plano: fundo
// claro e icone na cor) usado em todas as secoes.
export const FONTE = "'Poppins', system-ui, sans-serif";

export const COR = {
  tinta: '#1F1E1C',
  suave: '#6B655D',
  apagado: '#8C8478',
  borda: '#EDE4D6',
  linha: '#F1EBE1',
  creme: '#FDFBF7',
  azul: '#2C5FA8',
  azulEscuro: '#24518F',
  azulClaro: '#EAF1FA',
  roxo: '#6E2A80',
  roxoClaro: '#F3E8F6',
  laranja: '#D2551D',
  laranjaClaro: '#FBE7DB',
  verde: '#2F7A5B',
  verdeClaro: '#E6F3EC',
  vermelho: '#B4362E',
  vermelhoClaro: '#FBEAE8',
  dourado: '#E8B93C',
  douradoClaro: '#FCF1DA',
};

// Tons do bloco: [fundo claro, cor do ícone].
const PALETAS = {
  azul: ['#EAF1FA', '#2C5FA8'],
  roxo: ['#F3E8F6', '#7B3A92'],
  verde: ['#E6F3EC', '#2F7A5B'],
  laranja: ['#FBE7DB', '#D2551D'],
  rosa: ['#FBE6EB', '#C9405F'],
  dourado: ['#FCF1DA', '#8A6414'],
  indigo: ['#ECE8F8', '#5B3FB0'],
};

// Quadrado de ícone do kit. Até 15/10/2026 era um bloco "3D" (degradê,
// lateral escura, reflexo e sombra colorida); o Marcelo achou com cara de IA
// e ele virou plano: fundo claro + ícone na cor. O nome e as props ficaram
// iguais porque o componente é usado em ~40 lugares (Academy, Lab, Instrutor,
// Empresa) via este arquivo e o LabUi.
export function Bloco3D({ cor = 'azul', tamanho = 56, icone, numero }) {
  const [fundo, tom] = PALETAS[cor] || PALETAS.azul;
  const raio = Math.min(20, Math.round(tamanho * 0.28));
  return (
    <Box
      aria-hidden
      sx={{
        position: 'relative',
        flex: 'none',
        width: tamanho,
        height: tamanho,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: `${raio}px`,
        bgcolor: fundo,
        color: tom,
        '& svg': { fontSize: Math.round(tamanho * 0.46) },
      }}
    >
      {icone}
      {numero != null && (
        <Box
          sx={{
            position: 'absolute',
            right: -7,
            top: -7,
            minWidth: 22,
            height: 22,
            px: '4px',
            borderRadius: 99,
            bgcolor: tom,
            color: '#fff',
            border: '2px solid #fff',
            fontFamily: FONTE,
            fontSize: 11.5,
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {numero}
        </Box>
      )}
    </Box>
  );
}

export const sxCard = {
  width: '100%',
  boxSizing: 'border-box',
  bgcolor: '#fff',
  border: `1px solid ${COR.borda}`,
  borderRadius: '20px',
};

export function Secao({ titulo, subtitulo, rotulo, acao, children, cartao = false, sx }) {
  const cabecalho = (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'space-between', gap: '12px 20px' }}>
      <Box sx={{ minWidth: 0 }}>
        {rotulo && (
          <Typography sx={{ fontFamily: FONTE, fontSize: 12, fontWeight: 700, letterSpacing: '.16em', textTransform: 'uppercase', color: COR.azul, mb: '4px' }}>
            {rotulo}
          </Typography>
        )}
        <Typography component="h2" sx={{ fontFamily: FONTE, fontSize: { xs: 21, md: 24 }, fontWeight: 700, letterSpacing: '-.015em', color: COR.tinta }}>
          {titulo}
        </Typography>
        {subtitulo && <Typography sx={{ fontFamily: FONTE, fontSize: 14.5, color: COR.apagado, mt: '2px' }}>{subtitulo}</Typography>}
      </Box>
      {acao}
    </Box>
  );
  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        fontFamily: FONTE,
        ...(cartao ? { ...sxCard, p: { xs: '22px 18px', md: '28px 32px' } } : {}),
        ...sx,
      }}
    >
      {cabecalho}
      {children}
    </Box>
  );
}

export function Pilula({ children, cor = COR.suave, fundo = '#F4F1EB', icone, sx }) {
  return (
    <Box
      component="span"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: '5px', px: '10px', py: '4px', borderRadius: 99, bgcolor: fundo, color: cor, fontFamily: FONTE, fontSize: 12.5, fontWeight: 600, whiteSpace: 'nowrap', ...sx }}
    >
      {icone}
      {children}
    </Box>
  );
}
